export const PixelRatio = () => {
    return null
}